<template>
  <img :src alt="Logo" v-bind="size" loading="lazy" />
</template>

<script setup lang="ts">
import logo from './images/logo.svg'
import logoCompact from './images/logo-compact.svg'
import logoOutline from './images/logo-outline.svg'
import logoCompactOutline from './images/logo-compact-outline.svg'

const {
  compact = false,
  outline = false,
  width,
  height,
} = defineProps<{
  compact?: boolean
  outline?: boolean
  width?: number
  height?: number
}>()

const COMPACT_ASPECT_RATIO = 60 / 32
const ASPECT_RATIO = 180 / 44

const src = computed(() => {
  if (compact) {
    return outline ? logoCompactOutline : logoCompact
  }
  return outline ? logoOutline : logo
})

const size = computed(() => {
  if (width && height) {
    return {
      width,
      height,
    }
  }

  const aspectRatio = compact ? COMPACT_ASPECT_RATIO : ASPECT_RATIO

  if (width) {
    return {
      width,
      height: width / aspectRatio,
    }
  }

  if (height) {
    return {
      width: height * aspectRatio,
      height,
    }
  }

  return compact
    ? {
        width: 60,
        height: 32,
      }
    : {
        width: 180,
        height: 44,
      }
})
</script>
